import { HouseIcon } from "@phosphor-icons/react/dist/csr/House";
import { Link } from "react-router-dom";
import { Button } from "@volca/ui/components/ui/button";
import { PageTitle } from "@volca/ui/components/ui/page-components";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

export default function NotFound() {
  return (
    <Stack align="center" justify="center" className="min-h-full p-4">
      <Stack gap={6} align="center">
        <PageTitle>Page not found</PageTitle>
        <Text tone="muted" className="text-center">
          We can't seem to find the page you're looking for.
        </Text>
        <Button variant="ghost" render={<Link to="/" />} nativeButton={false}>
          <HouseIcon data-icon="inline-start" />
          Back home
        </Button>
      </Stack>
    </Stack>
  );
}
